import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/bio-medical-banner.png';
import '../styles/pages.css';
import YellowBag from '../components/img/yellow-bag.png';
import RedBag from '../components/img/red-bag.png';
import WhiteBag from '../components/img/white-bag.png';
import BrownishYellowBag from '../components/img/brownish-yellow-bag.png';
import BlueBag from '../components/img/blue-bag.png';

function BioMedical() {
    const [data, setData] = useState([]);
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [yearsMonths, setYearsMonths] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        // Fetch years and months from the backend
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_years_months.php')
            .then(response => response.json())
            .then(data => setYearsMonths(data))
            .catch(error => console.error('Error fetching year/month data:', error));

        // Fetch the latest biomedical data on page load
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_latest_biomedical_data.php')
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    setData(data);
                    setYear(data[0].year);
                    setMonth(data[0].month);
                }
            })
            .catch(error => console.error('Error fetching latest biomedical data:', error));
    }, []);

    const handleFilter = () => {
        if (!year || !month) {
            setError('Please select both year and month.');
            return;
        }
        setError('');
        // Fetch and display data based on selected year and month
        fetch(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_biomedical_data.php?year=${year}&month=${month}`)
            .then(response => response.json())
            .then(data => {
                console.log(data); // Inspect the data structure
                setData(data); // Update state with fetched data
            })
            .catch(error => console.error('Error fetching biomedical data:', error));
    };

    return (
        <div>
            <Navbar />
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Biomedical Waste Management</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Ensuring safe and environmentally responsible waste disposal 
                            <br />
                            practices at our hospital.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Ensuring safe and environmentally responsible waste disposal practices at our hospital.
                        </p>
                    </div>

                    <p className="page-subtitle">
                        
                    </p>
                    <div className="page-box">
                        <div className="box-content">
                            <p>Caritas Matha Hospital is dedicated to responsible and sustainable biomedical waste management, ensuring the safety of patients, staff, and the environment. Our comprehensive system adheres to strict regulatory standards, encompassing the segregation, collection, transportation, treatment, and disposal of biomedical waste.</p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Biomedical Banner" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='biomedical-content'>
                    <p className='page-content-heading'>
                        Caritas Matha Hospital :
                        <br />
                        Safeguarding Health, Safeguarding Earth
                    </p>
                    <br />
                    <div className='biomedical-details'>
                        <p>At Caritas Matha Hospital, we uphold a steadfast commitment to the well-being of our patients, staff, and the environment. Our dedicated Biomedical Waste Management program exemplifies our pledge to safe and sustainable waste disposal practices.</p>

                        <p>Recognizing the critical importance of managing biomedical waste responsibly, we employ a comprehensive approach to ensure all medical waste generated within our facility is handled, treated, and disposed of with utmost care. This meticulous process not only protects public health but also upholds environmental integrity.</p>

                        <p>In collaboration with IMAGE (Indian Medical Association Green Environment), Caritas Hospital proudly operates at the forefront of environmental responsibility. Our state-of-the-art systems and stringent protocols are designed to meet and exceed regulatory standards, guaranteeing the safety of our community and the planet at large. By adhering to these rigorous ethical and environmental principles, Caritas Hospital continues to lead by example in responsible healthcare waste management.</p>
                    </div>
                </div>

                <div className='filter-section'>
                    <br />
                    <p className='page-heading'>Real-time Biomedical Waste <br /> Management Data</p>
                    <div>
                        <br />
                        Filter Data by:
                        <select className='filter-option' name="year" id="year" onChange={(e) => setYear(e.target.value)}>
                            <option value="">Select Year</option>
                            {/* {yearsMonths.map((item, index) => (
                                <option key={index} value={item.year}>{item.year}</option>
                            ))} */}
                            <option value="2024">2024</option>
                        </select>

                        <select className='filter-option' name="month" id="month" onChange={(e) => setMonth(e.target.value)}>
                            <option value="">Select Month</option>
                            {yearsMonths.map((item, index) => (
                                <option key={index} value={item.month}>
                                    {new Date(0, item.month - 1).toLocaleString('en-US', { month: 'long' })}
                                </option>
                            ))}
                        </select>

                        <button type="button" className="filter-button" onClick={handleFilter} >Apply Filter</button>
                    </div>
                    <br/>
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}

                    {/* Displaying the selected year and month */}
                    {/* {year && month && (
                        <div style={{ margin: '20px 0' }}>
                            <h3 id="month_year">
                                {`${new Date(0, month - 1).toLocaleString('default', { month: 'long' })} ${year}`}
                            </h3>
                        </div>
                    )} */}

                    {data.length > 0 && (
                        data.map((item, index) => (
                            <div key={index}>
                                <h3 className='year_months' id="month_year">{new Date(item.month_year).toLocaleString('default', { month: 'long', year: 'numeric' })}</h3>
                                <div className="data-section">
                                    <div className="total-bags">
                                        <p>Total Bags</p>
                                        <h2 id="total_bags">{item.total_bags}</h2>
                                    </div>
                                    <div className="bag-div">
                                        <p><img src={YellowBag} className="bag-img" alt="Yellow Bag" />Yellow Bags</p>
                                        <h2 className="mx-4" id="yellow_bags">{item.yellow_bags}</h2>
                                    </div>
                                    <div className="bag-div">
                                        <p><img src={RedBag} className="bag-img" alt="Red Bag" />Red Bags</p>
                                        <h2 className="mx-4" id="red_bags">{item.red_bags}</h2>
                                    </div>
                                    <div className="bag-div">
                                        <p><img src={WhiteBag} className="bag-img" alt="White Bag" />White Bags</p>
                                        <h2 className="mx-4" id="white_bags">{item.white_bags}</h2>
                                    </div>
                                    <div className="bag-div-2">
                                        <p><img src={BrownishYellowBag} className="bag-img" alt="Brownish Yellow Bag" />Brownish Yellow Bags</p>
                                        <h2 className="mx-4" id="brownish_yellow_bags">{item.brownish_yellow_bags}</h2>
                                    </div>
                                    <div className="bag-div">
                                        <p><img src={BlueBag} className="bag-img" alt="Blue Bag" />Blue Bags</p>
                                        <h2 className="mx-4" id="blue_bags">{item.blue_bags}</h2>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default BioMedical;